import React from 'react';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageCouponsComponent from '@app/components/manage-coupons/list';

const ManageFirstRechargeCoupons: React.FC = () => {
  return (
    <>
      <PageTitle>First Recharge Coupons</PageTitle>
      <ManageCouponsComponent />
    </>
  );
};

export default ManageFirstRechargeCoupons;
